import dayjs from "dayjs";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import SearchListView from "../../components/SearchListView/SearchListView";
import { DATE_FORMAT_TIME, PAGINATOIN, SORT_DIRECTION } from "../../utils/constants";
import { removeUnderscore, replaceIfNull } from "../../utils/utils";
import "./RFMChanges.scss";
import { getRFMChangesList } from "../../store/actions/property.actions";

const RFMChanges = props => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [filterInfo, setFilterInfo] = useState(null);
  const [sortInfo, setSortInfo] = useState(null);

  const { list, loading, pagination } = useSelector(store => store.property);

  const fetchPropertyContacts = async query => {
    try {
      let _query = query;
      if (!_query) {
        _query = pagination;
      }
      await dispatch(getRFMChangesList(_query));
    } catch (ex) {
      console.log(ex);
    }
  };

  const columns = [
    {
      title: t("Table.PropertyCode"),
      dataIndex: "propertyCode",
      key: "propertyCode",
      sorter: true,
      sortDirections: SORT_DIRECTION.twoDirection,
      sortOrder: sortInfo?.field === "propertyCode" && sortInfo?.order,
      render: text => replaceIfNull(text, "N/A"),
    },
    {
      title: t("Table.PropertyName"),
      dataIndex: "propertyName",
      key: "propertyName",
      sorter: true,
      sortDirections: SORT_DIRECTION.twoDirection,
      sortOrder: sortInfo?.field === "propertyName" && sortInfo?.order,
      render: text => replaceIfNull(text, "N/A"),
    },
    {
      title: t("Table.PropertyType"),
      dataIndex: "type",
      key: "type",
      sorter: true,
      sortDirections: SORT_DIRECTION.twoDirection,
      sortOrder: sortInfo?.field === "type" && sortInfo?.order,
      render: text => <p className="text-capitalize">{replaceIfNull(removeUnderscore(text), "N/A")}</p>,
    },
    {
      title: t("Table.UnitId"),
      dataIndex: "unitId",
      key: "unitId",
      sorter: true,
      sortDirections: SORT_DIRECTION.twoDirection,
      sortOrder: sortInfo?.field === "unitId" && sortInfo?.order,
      render: text => replaceIfNull(text, "N/A"),
    },
    {
      title: t("Table.UnitCode"),
      dataIndex: "unitCode",
      key: "unitCode",
      sorter: true,
      sortDirections: SORT_DIRECTION.twoDirection,
      sortOrder: sortInfo?.field === "unitCode" && sortInfo?.order,
      render: text => replaceIfNull(text, "N/A"),
    },
    {
      title: t("Table.OldStatus"),
      dataIndex: "old_status",
      key: "old_status",
      sorter: true,
      sortDirections: SORT_DIRECTION.twoDirection,
      sortOrder: sortInfo?.field === "old_status" && sortInfo?.order,
      render: text => replaceIfNull(text, "N/A"),
    },
    {
      title: t("Table.NewStatus"),
      dataIndex: "new_status",
      key: "new_status",
      sorter: true,
      sortDirections: SORT_DIRECTION.twoDirection,
      sortOrder: sortInfo?.field === "new_status" && sortInfo?.order,
      render: text => replaceIfNull(text, "N/A"),
    },
    {
      title: t("Table.RFMOld"),
      dataIndex: "rfm_old",
      key: "rfm_old",
      sorter: true,
      sortDirections: SORT_DIRECTION.twoDirection,
      sortOrder: sortInfo?.field === "rfm_old" && sortInfo?.order,
      render: text => replaceIfNull(text, "N/A"),
    },
    {
      title: t("Table.RFMNew"),
      dataIndex: "rfm_new",
      key: "rfm_new",
      sorter: true,
      sortDirections: SORT_DIRECTION.twoDirection,
      sortOrder: sortInfo?.field === "rfm_new" && sortInfo?.order,
      render: text => replaceIfNull(text, "N/A"),
    },
    {
      title: t("Table.TimeStamp"),
      dataIndex: "timestamp",
      key: "timestamp",
      sorter: true,
      sortDirections: SORT_DIRECTION.reverse,
      sortOrder: sortInfo?.field === "timestamp" && sortInfo?.order,
      render: date => (date ? dayjs(date).format(DATE_FORMAT_TIME) : "N/A"),
    },
  ];

  return (
    <div className="rfm-unpublished-changes">
      <SearchListView
        paginationKey={PAGINATOIN.rfmChanges}
        setFilterInfo={setFilterInfo}
        setSortInfo={setSortInfo}
        rowKey="id"
        loading={loading}
        dataSource={list}
        columns={columns}
        getList={fetchPropertyContacts}
        pagination={pagination}
        defaultSort={{ field: "timestamp", order: "descend"}}
        scroll={{ y: "calc(100vh - 560px)", x: 1400 }}
      />
    </div>
  );
};

export default RFMChanges;
